// extracted by mini-css-extract-plugin
module.exports = {"link":"_3mOff","image":"_1Tmny","root":"_1RUPI"};